import { render, staticRenderFns } from "./GenderComponent.vue?vue&type=template&id=691725e3"
import script from "./GenderComponent.vue?vue&type=script&lang=js"
export * from "./GenderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports